import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section className="relative w-full bg-[#0f172a] pt-12 pb-20 px-4 md:px-6 overflow-hidden" data-id="element-92">
      <div className="max-w-3xl mx-auto text-center" data-id="element-93">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-94">
          <span className="inline-block py-1 px-3 rounded-full bg-[#1e293b] text-[#d4a574] text-sm font-semibold tracking-wide mb-6 border border-[#334155]" data-id="element-95">
            Der Schnarch- & Nasenfrei-Plan
          </span>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-[#faf5ef] leading-[1.1] mb-6 tracking-tight" data-id="element-96">
            Du brauchst kein neues Schnarch-Gadget.{' '}
            <br className="hidden md:block" data-id="element-97" />
            <span className="text-[#d4a574]" data-id="element-98">Du brauchst die Ursache.</span>
          </h1>

          <p className="text-lg md:text-xl text-[#94a3b8] font-medium mb-10" data-id="element-99">
            3‑Zonen‑Check · 14‑Nächte‑Log · Entscheidungsbaum
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-left bg-[#1e293b]/50 p-6 md:p-8 rounded-2xl border border-[#334155] mb-12 backdrop-blur-sm" data-id="element-100">
          <p className="text-[#cbd5e1] text-lg leading-relaxed mb-6" data-id="element-101">
            Du schnarchst. Vielleicht nicht jede Nacht. Vielleicht "nur, wenn du
            müde bist".
          </p>
          <p className="text-[#cbd5e1] text-lg leading-relaxed mb-6" data-id="element-102">
            Aber du kennst den Moment: Sie dreht sich weg. Oder sie stößt dich
            an. Oder du wachst auf — Mund trocken, Kopf schwer — und startest
            den Tag schon im Minus.
          </p>
          <p className="text-[#cbd5e1] text-lg leading-relaxed mb-6" data-id="element-103">
            Und dann machst du das, was fast jeder macht: Du kaufst irgendein
            Ding. Nasenpflaster. Spray. Neues Kissen.
          </p>
          <p className="text-[#cbd5e1] text-lg leading-relaxed mb-6" data-id="element-104">
            Drei Nächte Hoffnung. Dann wieder das gleiche.
          </p>
          <p className="text-[#d4a574] text-xl font-bold leading-relaxed" data-id="element-105">
            Nicht weil du zu wenig probiert hast. Sondern weil du ohne Ursache
            probierst.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="relative mb-12 rounded-2xl overflow-hidden shadow-2xl shadow-[#000000]/50 border border-[#334155]" data-id="element-106">
          <img src="https://cdn.magicpatterns.com/uploads/rqpwyKK69LxtsWmmAWJA7Z/Schnarch_Guide.png" alt="Der Schnarch- & Nasenfrei-Plan auf Tablet und Smartphone in warmer Schlafzimmer-Atmosphäre" className="w-full h-auto object-cover" data-id="element-107" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0f172a] via-transparent to-transparent opacity-60" data-id="element-108"></div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} data-id="element-109">
          <Button withIcon className="w-full md:w-auto text-lg px-10 py-5" onClick={() => {
          document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} data-id="element-110">
            Jetzt den Plan holen
          </Button>
          <p className="mt-4 text-sm text-[#64748b]" data-id="element-111">
            Sofortiger Download als PDF + Tracker
          </p>
        </motion.div>
      </div>
    </section>;
}